export default "__VITE_ASSET__DVWrczMP__"